import { Form, Formik } from 'formik';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { ICopyProduct } from '../../../models/forms/ICopyProduct';
import { IAddEditFormProps } from '../../../models/forms/IForm';
import FormLoader from '../../../shared-components/FormLoader/FormLoader';
import Label from '../../../shared-components/label/label';
import DefaultModalDraggable from '../../../shared-components/modal/default-modal-draggable';
import ModalFooter from '../../../shared-components/modal/modal-footer';
import { formatMessage } from '../../../translations/format-message';

const validateCopyProduct = (values: ICopyProduct) => {
  const errors: Partial<Record<keyof ICopyProduct, string>> = {};
  const rawProductId = String(values.NewProductId || '');
  const newProductId = rawProductId.trim();

  if (!newProductId) {
    errors.NewProductId = 'field_required';
  } else if (rawProductId.startsWith(' ')) {
    errors.NewProductId = 'whitespace_code_error';
  } else if (!/^[0-9]+$/.test(newProductId)) {
    errors.NewProductId = 'only_numbers_allowed';
  }

  return errors;
};

const CopyProductForm = ({
  id,
  initialValues,
  isLoading,
  submitHandler,
  onModalClosed,
}: IAddEditFormProps<ICopyProduct>) => {
  return (
    <>
      <DefaultModalDraggable
        onModalClosed={onModalClosed}
        headerText={'copy_product'}
        isLoading={isLoading}
        className="addProcess"
        saveUpdateBtnText={'save'}
        cancelBtnText={'cancel'}
      >
        <Formik
          initialValues={initialValues}
          enableReinitialize
          validate={validateCopyProduct}
          validateOnBlur={false}
          onSubmit={async (values) => {
            submitHandler(values);
          }}
        >
          {({ values, errors, touched, setFieldValue, setFieldTouched }) => {
            const newProductId = String(values.NewProductId || '');
            const isProductIdLimitReached = newProductId.length >= 10;

            return (
              <Form className="process-form">
              {isLoading && <FormLoader loading={isLoading} />}
              <Modal.Body>
                <div className="row">
                  <div className="col-12">
                    <div className="form-group formSet">
                        <Label
                          className="label-style col-form-label"
                          required={true}
                          label="new_product_id"
                        />
                      <input
                        data-testid="testNewProductId"
                        className={`form-control ${
                          errors.NewProductId && touched.NewProductId
                            ? 'error'
                            : ''
                        }`}
                        name="NewProductId"
                        type="text"
                        inputMode="numeric"
                        maxLength={10}
                        placeholder=""
                        value={newProductId}
                        onChange={(e: any) => {
                          const rawValue = e.target.value || '';
                          const digitsOnly = rawValue.replace(/\D/g, '');
                          const trimmedValue = digitsOnly.slice(0, 10);

                          setFieldValue('NewProductId', trimmedValue, true);
                        }}
                        onBlur={() => {
                          setFieldTouched('NewProductId', true, true);
                        }}
                        />
                      {isProductIdLimitReached ? (
                        <span className="text-danger errorMessage">
                          {formatMessage('max_char_product_name')}
                        </span>
                      ) : touched.NewProductId && errors.NewProductId ? (
                        <span className="text-danger errorMessage">
                          {formatMessage(String(errors.NewProductId))}
                        </span>
                      ) : null}
                    </div>
                  </div>
                </div>
              </Modal.Body>
                <ModalFooter
                  id={id}
                  onModalClosed={onModalClosed}
                        isLoading={isLoading}
                  saveNextBtn={'save'}
                  backCancelBtn="cancel"
                      />
            </Form>
            );
          }}
        </Formik>
      </DefaultModalDraggable>
    </>
  );
};

export default CopyProductForm;
